import React, { lazy, useEffect, useContext } from 'react';
import Suspense from '../../element/Suspense';
import { SubmenuContext } from '../../element/Menu/submenuContext';
import SubMenuItems from '../../element/Menu/SubMenuItems';

const MyPerformancesView = lazy(() => import('./view'));

const MyPerformances = ({ routes }: { routes: Record<any, any> }): React.ReactElement => {
  const { setSubmenu } = useContext(SubmenuContext);
  useEffect(() => {
    if (setSubmenu) {
      setSubmenu(SubMenuItems.myPerformance.key);
    }
  }, [setSubmenu]);

  return (
    <Suspense>
      <MyPerformancesView routes={routes} />
    </Suspense>
  );
};

export default MyPerformances;
